import type { AudienceFilters } from '@brushfire/types'
import { env } from '@/config/env'

/** BFP-252 TC-TA-05 — amber “very few” footnote when count is below this (fixed at 10 per user story). */
export const VERY_LOW_MATCH_COUNT_THRESHOLD = 10

/** Minimum SP count to enable Next / budget gates (`VITE_MIN_SP_TARGET_AUDIENCE`, default 800). */
export const MIN_SIGNAL_PROVIDERS = env.VITE_MIN_SP_TARGET_AUDIENCE

/** Vitest-only fixture — not used at runtime (live suggest comes from campaign MS). */
export const TEST_AI_AUDIENCE_BASELINE: AudienceFilters = {
  ageRange: { min: 21, max: 35 },
  gender: ['female'],
  location: { state: 'NY' },
  education: ['bachelors'],
  employment: ['full_time'],
  deviceType: ['mobile', 'web'],
  maritalStatus: ['single'],
  householdSize: ['1'],
  numberOfChildren: ['none'],
  industry: ['technology'],
  housingStatus: ['rent'],
}
